import type { Message } from '@/model';
import { number,record } from './types';

/** Recognition belongs to the recording; a review gate belongs to one message/recording. */
export class TranscriptFacts {
 private readonly content=new Map<string,Record<string,unknown>>();
 private readonly reviews=new Map<string,Record<string,unknown>>();
 rememberValue(mediaId:string,messageId:string,value:unknown):void {
  const next=record(value);if(typeof next.revision!=='number')return;
  const held=this.content.get(mediaId);
  if(!held||number(next.revision)>=number(held.revision)){
   const content={...next};delete content.review;this.content.set(mediaId,content);
  }
  const review=record(next.review),key=messageId+':'+mediaId,prior=this.reviews.get(key);
  if(typeof review.revision==='number'&&(!prior||number(review.revision)>=number(prior.revision)))this.reviews.set(key,{...review});
 }
 remember(message:Message):void {
  for(const part of message.parts)if(part.type==='media'&&part.kind==='audio'&&typeof part.media_id==='string')this.rememberValue(part.media_id,message.id,part.transcript);
 }
 project(message:Message):Message {
  return {...message,parts:message.parts.map(part=>{
   if(part.type!=='media'||part.kind!=='audio'||typeof part.media_id!=='string')return part;
   const content=this.content.get(part.media_id);if(!content)return part;
   return {...part,transcript:{...content,review:this.reviews.get(message.id+':'+part.media_id)??null}};
  })};
 }
 merge(prior:Message|undefined,incoming:Message):Message {
  if(prior)this.remember(prior);this.remember(incoming);
  return this.project(prior&&prior.revision>incoming.revision?prior:incoming);
 }
}
